import { getheader, setErrorDialog, serverUrl, postMethodByCallBack, postMethodByDispatcher, getMethodByCallBack, cacheTypes } from "../../../store/api/CommonFunctions";

export function GetTaskDetails(serviceid, type) {

  var token = localStorage.getItem('token')
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + "ReceptionTasksApi/GetService/?ServiceID=" + serviceid + '&serviceType=' + type, {
      headers: {
        "token": token
      },
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        dispatch({ type: "LOADING", data: false })
        return dispatch({
          type: "GET_TASKS_DETAILS",
          data: res
        })

      }).catch(err => console.error('[err]', err));
  };
}
export function GetStatusList() {

  var token = localStorage.getItem('token')
  return dispatch => {
    fetch(serverUrl + "ReceptionTasksApi/StaffReportBySMSServiceSelectAll/", {
      headers: {
        "token": token
      },
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        return dispatch({
          type: "GET_TASKS_STATUS",
          data: res
        })

      }).catch(err => console.error('[err]', err));

  };
}
export function getExtraServiceData(serviceid, type) {

  return dispatch => {
    dispatch({
      type: "GET_TASKS_EXTRA",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetExtraServiceData/?ServiceID=${serviceid}&ServiceType=${type}`, {
      headers: getheader(),
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        if (res.Message === "Error") {
          res = null;
        }
        return dispatch({
          type: "GET_TASKS_EXTRA",
          data: res
        });

      }).catch(err => {
        console.error('[err]', err);
        return dispatch({
          type: "GET_TASKS_EXTRA",
          data: null
        });

      });

  };
}
export function deleteExtraServiceData(serviceid, type, id, fn) {

  var token = localStorage.getItem('token')
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/DeleteExtraService?ServiceID=${serviceid}&ServiceType=${type}&ID=${id}`, {
      headers: {
        "Token": token
      },
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        if (res.Message || !res.List) {
          setErrorDialog(dispatch, res.Message, "حذف سایر خدمات سرویس");
          return;
        }
        if (fn) {
          fn(res);
        }
        dispatch({
          type: "GET_TASKS_EXTRA",
          data: res.List
        });

      }).catch(err => console.error('[err]', err));

  };
}
export function saveExtraService(data, fn) {

  var token = localStorage.getItem('token')
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/SaveExtraService/`, {
      headers: {
        "Token": token,
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(data),
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        if (res.Message || !res?.List) {
          setErrorDialog(dispatch, res.Message, "ثبت سایر خدمات");
          return;
        }
        fn(res);
        dispatch({
          type: "GET_TASKS_EXTRA",
          data: res.List
        })

      }).catch(err => console.error('[err]', err));
  };
}
export function saveServiceRefferal(data, fn) {

  var token = localStorage.getItem('token')
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/SaveServiceRefferal/`, {
      headers: {
        "Token": token,
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(data),
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        if (res.Message || !res?.List) {
          setErrorDialog(dispatch, res.Message, "ثبت مراجعه");
          return;
        }
        fn(res);
        dispatch({
          type: "GET_REFERALS",
          data: res.List
        })


      }).catch(err => console.error('[err]', err));
  };
}
export function deleteServiceReferral(refID, serviceType, fn) {

  var token = localStorage.getItem('token')
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/DeleteServiceReferral?refID=${refID}&serviceType=${serviceType}`, {
      headers: {
        "Token": token
      },
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        if (res.Message || !res?.List) {
          setErrorDialog(dispatch, res.Message, "حذف مراجعه");
          return;
        }
        fn(res);
        dispatch({
          type: "GET_REFERALS",
          data: res.List
        })


      }).catch(err => console.error('[err]', err));
  };
}
export function getServiceReferral(id, type) {


  return dispatch => {
    dispatch({
      type: "GET_REFERALS",
      data: "PENDING"
    })
    fetch(serverUrl + `ReceptionTasksApi/GetServiceReferral/?serviceType=${type}&serviceId=${id}`, {
      headers: getheader(),
      method: 'get',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        return dispatch({
          type: "GET_REFERALS",
          data: res
        });

      }).catch(err => console.error('[err]', err));
  };
}
export function getServiceDefinedData(id, type) {

  return dispatch => {
    dispatch({
      type: "GET_DEFINED_SERVICE",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetServiceDefinedData/?serviceType=${type}&serviceId=${id}`, {
      headers: getheader(),
      method: 'get',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        if (res.Message === "Error") {
          res = null;
        }
        return dispatch({
          type: "GET_DEFINED_SERVICE",
          data: res
        })

      }).catch(err => {
        console.error('[GET_DEFINED_SERVICE]', err);
        return dispatch({
          type: "GET_DEFINED_SERVICE",
          data: null
        });
      });
  };
}
export function getDefinedServices(itemDesc, pageSize) {

  return dispatch => {
    dispatch({
      type: "GET_DEFINED_SERVICE_LIST",
      data: "Pending"
    })
    fetch(serverUrl + `ReceptionTasksApi/GetDefinedServices/?PageSize=${pageSize ?? 10}&PageNumber=${1}&itemDesc=${itemDesc}`, {
      headers: getheader(),
      method: 'get',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        if (res.Message === "Error") {
          res = null;
        }
        return dispatch({
          type: "GET_DEFINED_SERVICE_LIST",
          data: res
        })

      }).catch(err => {
        dispatch({
          type: "GET_DEFINED_SERVICE_LIST",
          data: null
        });
        console.error('[GET_DEFINED_SERVICE_LIST]', err)
      });
  };
}
export function getDefinedServicesForSelect(data, onGet) {
  postMethodByCallBack("api/DefinedServiceCostsAPI/GetDefinedServiceCostsForSelect", data, onGet, "GetDefinedServiceCostsForSelect");
}
export function saveDefinedService(data, onSuccess) {

  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });

    fetch(serverUrl + `ReceptionTasksApi/SaveDefinedService/`, {
      headers: getheader(),
      body: JSON.stringify(data),
      method: 'POST',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (res.Message || !res.List) {
          setErrorDialog(dispatch, res.Message, "ثبت خدمات سرویس");
          return;
        }
        onSuccess(res);

        return dispatch({
          type: "GET_DEFINED_SERVICE",
          data: res.List,
        })

      }).catch(err => {
        console.error('[err]', err); dispatch({
          type: "LOADING",
          data: false
        });
      });
  };
}
export function DeleteDefinedService(id, type, onSuccess) {

  var token = localStorage.getItem('token')
  return dispatch => {

    dispatch({
      type: "DELETED_RESULT",
      data: "PENDING"
    })

    fetch(serverUrl + `ReceptionTasksApi/DeleteDefinedService/?ID=${id}&ServiceType=${type}`, {
      headers: {
        "Token": token,
      },
      method: 'get',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        if (res.Message || !res.List) {
          setErrorDialog(dispatch, res.Message, "حذف خدمات سرویس");
          return;
        }
        onSuccess(res);

        return dispatch({
          type: "GET_DEFINED_SERVICE",
          data: res.List,
        })

      }).catch(err => {
        console.error('[err]', err);
        alert("اشکال در انجام علمیات");
        return dispatch({
          type: "DELETED_RESULT",
          data: null
        })
      });
  };
}
export function setDefinedServicesPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_DEFINEDSERVICES_POPUP",
      data: status
    });
  }
}
export function loadServiceAccessories(serviceID, serviceType) {
  return dispatch => {
    dispatch({
      type: "SERVICE_ACCESSORIES",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksAPI/LoadServiceDetails?serviceID=${serviceID}&serviceType=${serviceType}&detailType=0`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || res.Message) {
          res = null;
          alert("اشکال در بازیابی لیست لوازم همراه سرویس");
        }
        return dispatch({
          type: "SERVICE_ACCESSORIES",
          data: res
        });
      }).catch(e => {
        console.log("[ERVICE_ACCESSORIES]", e);
        return dispatch({
          type: "SERVICE_ACCESSORIES",
          data: null
        });
      })
  }
}
export function deleteServiceDetail(id, onSuccess) {
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/DeleteServiceDetail?id=${id}`, {
      headers: getheader(),
      method: "DELETE"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || res.Message) {
          alert("اشکال در انجام عملیات");
        }
        else {
          if (onSuccess) {
            onSuccess();
          }
        }

      })
  }
}
export function addServiceDetail(data, onSuccess) {
  fetch(serverUrl + `ReceptionTasksApi/AddNewServiceDetail`, {
    headers: getheader(),
    body: JSON.stringify(data),
    method: "POST"
  }).then(res => res.json())
    .then(res => {
      if (res === "Error" || res.Message) {
        // alert("اشکال در انجام عملیات");
      }
      else if (onSuccess) {
        // alert("عملیات با موفقیت انجام شد");
        onSuccess();
      }
    }).catch(e => {
      // alert("اشکال در انجام عملیات");
      console.log("[ADD_SERVICE_DETAIL]", e);
    })
}
export function addServiceDetails(data, onSuccess) {
  postMethodByCallBack(`ReceptionTasksApi/AddNewServiceDetails`, data, onSuccess, "AddNewServiceDetails");
}
export function addOrUpdateModalDefinedServiceCosts(data, onAddUpdate) {
  postMethodByCallBack(`api/DefinedServiceCostsAPI/AddOrUpdateDefinedCost`, data, onAddUpdate, "AddOrUpdateDefinedCost");
}
export function getDefinedServiceCosts(data, onGetData) {

  postMethodByCallBack(`api/DefinedServiceCostsAPI/GetDefinedServiceCosts`, data, onGetData, "DEFINED_SERVICE_COSTS");

}
export function deleteDefinedServiceCost(id, onDelete) {
  return () => {
    getMethodByCallBack(`api/DefinedServiceCostsAPI/DeleteDefinedServiceCost?Id=${id}`, cacheTypes.NoCache, onDelete, "DeleteDefinedCost");
  }
}
export function getNextDefinedCode(onGetCode) {
  getMethodByCallBack('api/DefinedServiceCostsAPI/GetNextDefinedCode', cacheTypes.NoCache, onGetCode, "GetNextDefinedCode");
}
export function searchProductBug(data) {
  return dispatch => {
    dispatch(postMethodByDispatcher("api/ProductBugAPI/SearchProductBug", data, "SEARCH_PRODUCT_BUG", "دریافت لیست ایرادات"))
  }
}
export function addEditProductBug(data, onAddEdit) {
  return dispatch => {
    const onSuccess = (res) => {
      if (res.Data) {
        dispatch({
          type: "SEARCH_PRODUCT_BUG",
          data: res
        })
      }
      onAddEdit(res);
    }
    postMethodByCallBack(`api/ProductBugAPI/AddOrUpdateProductBug?takeList=${true}`, data, onSuccess, "AddOrUpdateProductBug");
  }
}
export function getNextProductBugCode(onGet) {
  getMethodByCallBack("api/ProductBugAPI/GetNextBugCode", cacheTypes.NoCache, onGet, "GetNextBugCode");
}
export function deleteProductBug(id, onDelete) {
  return dispatch => {
    const onSuccess = (res) => {
      if (res.Data) {
        dispatch({
          type: "SEARCH_PRODUCT_BUG",
          data: res
        })
      }
      onDelete(res);
    }
    getMethodByCallBack(`api/ProductbugAPI/DeleteProductBug?Id=${id}&takeList=true`, cacheTypes.NoCache, onSuccess, "DeleteProductBug");
  }
}


